module.exports = __webpack_public_path__ + "static/img/honor16.dc4a6fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/honor/honor16.jpg
// module id = Xtyf
// module chunks = 1